/**
 * Componente copiado de ADF 5.0.0 y adaptado a nuestras necesidades
 */

import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ConfigurableFocusTrap, ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import { MatMenuTrigger } from '@angular/material/menu';
import { CustomDataColumn } from 'projects/alden-extension/src/lib/models/custom-viewer-config';
import { SMTSearchWidgetContainerComponent } from '../search-widget-container/search-widget-container.component';
import { KeyValue } from '@angular/common';
import { ExtensionService } from '@alfresco/adf-extensions';
import { CustomRuleContext } from 'projects/alden-extension/src/lib/models/custom-rule-context';
import { CustomUserPreferencesService } from 'projects/alden-extension/src/lib/services/custom-user-preferences-service';

@Component({
  selector: 'smt-search-widget-chip',
  templateUrl: './search-widget-chip.component.html',
  styleUrls: ['./search-widget-chip.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SMTSearchWidgetChipComponent implements AfterViewInit {

    @Input()
    filter: CustomDataColumn;

    @ViewChild('menuContainer', { static: false })
    menuContainer: ElementRef;

    @ViewChild('menuTrigger', { static: false })
    menuTrigger: MatMenuTrigger;

    @ViewChild(SMTSearchWidgetContainerComponent, { static: false })
    widgetContainerComponent: SMTSearchWidgetContainerComponent;

    /** Emitted when a filter value is selected */
    @Output()
    filterChange: EventEmitter<KeyValue<string,string>> = new EventEmitter();
    @Output()
    submitQuery: EventEmitter<void> = new EventEmitter();

    focusTrap: ConfigurableFocusTrap;

    title: string;

    editable: boolean;

    constructor(private focusTrapFactory: ConfigurableFocusTrapFactory, protected extensions: ExtensionService, private cdRef: ChangeDetectorRef, private customUserPreferencesService: CustomUserPreferencesService) {
        this.editable = true;
    }

    ngAfterViewInit(): void {
        this.title = this.filter.search.title ?? this.filter.title;
        this.cdRef.detectChanges();

        //Ver si setear algún filtro pasado por parámetro
        const value = this.filter.search.settings?.defaultValue;
        if(value !== undefined) {
            this.widgetContainerComponent.setValue(value);
            this.setCurrentQuery();
        }

        this.evaluateEditable();
    }

    evaluateEditable() {
        const context = { filter: this.filter } as CustomRuleContext;
        if(this.filter.search.editable && !this.extensions.evaluateRule(this.filter.search.editable, context)) {
            this.disableFilter();
        } else  {
            this.enableFilter();
        }
    }

    onMenuOpen() {
        if (this.menuContainer && !this.focusTrap) {
            this.focusTrap = this.focusTrapFactory.create(this.menuContainer.nativeElement);
            //this.focusTrap.focusInitialElement();        
        }
        this.widgetContainerComponent.emitOnOpened(); 
    }

    onClosed() {
        this.focusTrap?.destroy();
        this.focusTrap = null;
        this.widgetContainerComponent.emitOnClosed();
    }

    resetCurrentQuery() {
        this.widgetContainerComponent.resetInnerWidget();
        this.filterChange.emit({ 'key': this.field, 'value': this.widgetContainerComponent.getCurrentQuery()});
    }

    onRemove() {
        this.customUserPreferencesService.deleteFromAppliedValues(this.filter!.id!);
        this.resetCurrentQuery();
        this.submitQuery.emit();
        this.menuTrigger.closeMenu();
    }

    async setCurrentQuery() {
        await this.widgetContainerComponent.applyInnerWidget();
        this.filterChange.emit({ 'key': this.field, 'value': this.widgetContainerComponent.getCurrentQuery()});
    }

    async onApply() {
        await this.setCurrentQuery();
        const val = this.getAppliedValue();
        this.customUserPreferencesService.pushAppliedValue(this.filter!.id!,val);
        this.submitQuery.emit();
        this.menuTrigger.closeMenu();
    }

    reset(){
        this.widgetContainerComponent.resetInnerWidget();
        this.resetCurrentQuery();
    }

    refreshFilterChip() {
        this.widgetContainerComponent.refreshFilterInnerWidget();
    }

    disableFilter() {
        this.editable = false;
        this.widgetContainerComponent.disable();
    }

    enableFilter() {
        this.editable = true;
        this.widgetContainerComponent.enable();
    }

    hasValidValue() {
        return this.widgetContainerComponent?.hasValidValue();
    }

    getAppliedValue(): any {
        const val = this.widgetContainerComponent?.getAppliedValue();
        return val;
    }

    get field() : string {
        const settings = this.filter.search.settings;
        if(settings) {
            const field = settings.field;
            if(field)
                return field;
        } else {
            const key = this.filter.key.split('properties.');
            if(key.length === 2)
                return key[1];
        }
        return "";
    }

    setSavedValue(value:any){
        this.widgetContainerComponent.setValue(value);
        this.setCurrentQuery();
        this.onApply();
    }

}
